import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "user",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/users`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setUsers(res.data.users);
    } catch (error) {
      console.error(
        "Error fetching users:",
        error.response?.data?.error || error.message
      );
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { name, email, password } = formData;

    // Validation
    if (!name || !email || !password) {
      Swal.fire("Warning", "All fields are required.", "warning");
      setLoading(false);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Swal.fire("Error", "Invalid email format.", "error");
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      Swal.fire("Error", "Password must be at least 6 characters.", "error");
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/add-user`,
        formData,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      Swal.fire("Success", res.data.message, "success");
      setFormData({
        name: "",
        email: "",
        password: "",
        role: "user",
      });
      fetchUsers();
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.error || "Failed to add user.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (userId) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/status-change`,
        { userId },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      Swal.fire("Success", res.data.message, "success");
      fetchUsers();
    } catch (error) {
      Swal.fire("Error", "Failed to update user status.", "error");
    }
  };

  return (
    <div
      className="container"
      style={{ minHeight: "80vh", backgroundColor: "aliceblue" }}
    >
      <h1 className="mb-4 text-center">Admin Dashboard</h1>

      <div className="card p-4 mb-4 shadow-sm">
        <h2 className="h4 mb-3">Add New User</h2>
        <form onSubmit={handleSubmit}>
          <div className="row mb-3">
            <div className="col-md-10 mb-2">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <div className="col-md-10 mb-2">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="form-control"
              />
            </div>
            <div className="col-md-10 mb-2">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                className="form-control"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn btn-outline-primary w-100 fw-bold"
          >
            {loading ? "Adding..." : "Add User"}
          </button>
        </form>
      </div>

      <div className="card p-4 shadow-sm table-responsive">
        <h2 className="h4 mb-3">User List</h2>
        {users.length === 0 ? (
          <p className="text-muted">No users found.</p>
        ) : (
          <table className="table table-striped text-center">
            <thead className="table-dark">
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user._id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td
                    className={`fw-bold ${
                      user.status === "active" ? "text-success" : "text-danger"
                    }`}
                  >
                    {user.status}
                  </td>
                  <td>
                    <button
                      className={`fw-bold btn ${
                        user.status === "active" ? "btn-warning" : "btn-info"
                      } btn-sm`}
                      onClick={() => handleStatusChange(user._id)}
                    >
                      {user.status === "active" ? "Deactivate" : "Activate"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AllUsers;
